import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './a2356b88ee976e8f5a7d71b522429ab5c2b057d7b1d1239a54eae91d301dd39f.cfe-internal.js';
import Check from './a2b9eb676e29370706d8c4b2ecba891458581287ea2910459a1e593c4c4cba0e.cfe-internal.js';
import { useFormFieldContext } from '../FormField/ff8bdfb918b98e400d01f1272050447aed13a9c7dbe824884d42b110edddae42.cfe-internal.js';
import concatIds from '../../utils/concatIds/4f58d37595ecc5912f64ecb84828b103f66a43e895e850434f09170560f4b3d7.cfe-internal.js';

var _excluded = ["id", "className", "checked", "defaultChecked", "disabled", "onChange", "value", "name", "inputProps", "aria-label", "aria-labelledby", "aria-describedby"];
var Checkbox = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      className = _ref.className,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      value = _ref.value,
      name = _ref.name,
      inputProps = _ref.inputProps,
      externalAriaLabel = _ref['aria-label'],
      externalAriaLabelledBy = _ref['aria-labelledby'],
      externalAriaDescribedBy = _ref['aria-describedby'],
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFormFieldContext = useFormFieldContext(),
      formFieldHelperTextId = _useFormFieldContext.helperTextId,
      formFieldErrorTextId = _useFormFieldContext.errorTextId;

  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId, inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-describedby']);
  return /*#__PURE__*/React__default.createElement("span", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.checkbox)
  }), /*#__PURE__*/React__default.createElement("input", _extends({}, inputProps, {
    name: name !== null && name !== void 0 ? name : inputProps === null || inputProps === void 0 ? void 0 : inputProps.name,
    className: classNames(styles.input, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className),
    type: "checkbox",
    id: id !== null && id !== void 0 ? id : inputProps === null || inputProps === void 0 ? void 0 : inputProps.id,
    checked: checked !== null && checked !== void 0 ? checked : inputProps === null || inputProps === void 0 ? void 0 : inputProps.checked,
    defaultChecked: defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : inputProps === null || inputProps === void 0 ? void 0 : inputProps.defaultChecked,
    disabled: disabled !== null && disabled !== void 0 ? disabled : inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled,
    onChange: disabled ? undefined : onChange !== null && onChange !== void 0 ? onChange : inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange,
    value: value !== null && value !== void 0 ? value : inputProps === null || inputProps === void 0 ? void 0 : inputProps.value,
    "aria-label": externalAriaLabel !== null && externalAriaLabel !== void 0 ? externalAriaLabel : inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-label'],
    "aria-labelledby": externalAriaLabelledBy !== null && externalAriaLabelledBy !== void 0 ? externalAriaLabelledBy : inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-labelledby'],
    "aria-describedby": internalAriaDescribedby
  })), /*#__PURE__*/React__default.createElement("span", {
    className: styles.check
  }, /*#__PURE__*/React__default.createElement(Check, {
    className: styles.checkIcon
  })));
});
var Checkbox$1 = Checkbox;

export { Checkbox$1 as default };
